import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleSquareFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.501 6.638v-.003C.507 5.88.532 5.215.59 4.63.94 1.073 2.479.5 8 .5c6.563 0 7.5.81 7.5 6.477 0 5.668-.937 6.477-7.5 6.477-1.316 0-2.405-.032-3.306-.13L.5 15.5V6.636zM11.333 6.3H4.667V4.9h6.666zM4.667 7.567H10v1.4H4.667z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
BubbleSquareFilledSize16Glyph.displayName = 'BubbleSquareFilledSize16Glyph';
